<template>
  <div v-if="data?.length > 0" class="flex gap-3 xl:gap-4">
    <template v-for="(item, index) in data">
      <a
        v-if="item.enabled"
        :key="index"
        :href="item.link"
        target="_blank"
        rel="noopener noreferrer"
        class="duration-200"
        :class="socialLinkClass"
        :aria-label="item.title"
      >
        <AtomsSvg :width="28" :height="28" :icon="item.icon?.iconData" />
      </a>
    </template>
  </div>
</template>
<script setup>
const props = defineProps({
  data: {
    type: Array,
  },
  color: {
    type: String,
  },
});
import { computed } from 'vue';
const socialLinkClass = computed(() => props.color === 'text-white' ? ' text-white hover:text-white/50' : ' text-black hover:text-black/50');
</script>
